<template>
  <nuttrema-layout-east-block>
    <east-search
      :list="StuffToEatList"
      @pageChange="doPageChange"
      @itemClick="onItemClick"
      @search="doSearch"
      @filterByOrigin="doFilterByOrigin">
      <template v-if="meta.navigation.back" slot="top-title-left">
        <a :title="$t('label.back')" @click="onBackEvent">
          <i class="far fa-chevron-left"></i>
        </a>
      </template>
      <template slot="top-title-center">{{ title }}</template>
    </east-search>
    <router-view></router-view>
  </nuttrema-layout-east-block>
</template>

<script>
import Vue from 'vue';

import * as KEYS from 'constants/keys';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutEastBlock from 'components/ui/layout/nuttrema-layout-east-block';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import ServerSidePageList from 'components/mixins/server-side-page-list';
// import MonitoredState from 'components/mixins/monitored-state';

import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';

import EastSearchFilter from 'components/ui/search/east-search-filter';

import EastSearch from 'components/ui/search/east-search';

export default {
  name: 'page-search-stuff-to-eat',
  mixins: [
    PageProps,
    ServerSidePageList,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    entityType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      paramsDefault: {
        context: 'use',
        group_by: 'type_category',
        include: 'nutrition_info,image,manufacturer,allergens',
        exclude: this.id ? `id,${this.id}` : null,
        per_page: 100,
      },
      localStorageKey: KEYS.PAGE_SEARCH_STUFF_TO_EAT,
    };
  },
  computed: {
    StuffToEatList() {
      return this.$store.getters.StuffToEatList(this.entityType);
    },
    title() {
      const value = `label.search_${this.entityType}`;
      return this.$t(value.replace(/-/g, '_'));
    },
  },
  methods: {
    onItemClick(id) {
      const name = this.getMetaAttr('navigation.itemClickNavigation');
      const param = this.getMetaAttr('navigation.itemParamName');

      const data = {
        name,
        params: {},
      };

      Vue.set(data.params, param, id);

      this.$router.push(data);
    },
    fetch() {
      this.$store.dispatch('GetStuffToEatList', {
        type: this.entityType,
        params: this.params,
      });
    },
    clean() {
      this.$store.dispatch('ClearStuffToEatList', { type: this.entityType });
    },
  },
  components: {
    EastSearch,
    EastSearchFilter,
    NuttremaIconicaKcal,
    NuttremaLayoutEastBlock,
    NuttremaLayoutWestThreeVertical,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/search-east/page-search-stuff-to-eat.vue